export default "__VITE_ASSET__DiRBJVaO__"